import { __assign } from "tslib";
export var DEFAULT_AUTH_DATA_VALUES = {
    token: undefined,
    staticSourceUrl: "",
    isSupportWebp: false,
};
export var DEFAULT_AUTH_DATA_CONTEXT = __assign(__assign({}, DEFAULT_AUTH_DATA_VALUES), { setAuthParams: function () { } });
